module.exports = __webpack_public_path__ + "img/boxed-14.6a759709.jpg";